import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthPayload, checkAuthStatus, getAuthPayload } from "../utils/auth";

type AuthContextType = {
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
  user?: AuthPayload;
  hasPermission: (required: string) => boolean;
};

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(checkAuthStatus());
  const [user, setUser] = useState<AuthPayload | undefined>(getAuthPayload());

  // useEffect(() => {
  //   setIsAuthenticated(checkAuthStatus());
  //   setUser(getAuthPayload());
  // }, []);

  const login = (token: string) => {
    setIsAuthenticated(true);
    localStorage.setItem("token", token);
    setUser(getAuthPayload());
  };
  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("storeId");
  };

  const hasPermission = (required: string) => {
    if (!user) return false;
    if (user.role === "ADMIN") return true;
    if (!user.permissions) return false;
    return user.permissions.includes(required);
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, login, logout, user, hasPermission }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
